import styled from 'styled-components';
import { baseVariables } from '../../styles';

const { spacers, mediaQuery } = baseVariables;

export const Wrapper = styled.section`
  /* Additional OHighlight Wrapper styling if needed */
`;

export const Grid = styled.div<{ numItems: number }>`
  display: grid;
  gap: ${spacers?.spacers?.[4] ?? '1.5rem'};
  --grid-item-width: 1fr;
  grid-template-columns: var(--grid-item-width);

  @media ${mediaQuery.md} {
    // 2 or 4 items should be in 2 columns; otherwise 3, 5, or 6 items should be in 3 columns
    grid-template-columns: repeat(
      ${({ numItems }) => (numItems < 6 && numItems % 2 === 0 ? 2 : 3)},
      var(--grid-item-width)
    );
  }

  @media ${mediaQuery.lg} {
    grid-template-columns: repeat(${({ numItems }) => numItems}, var(--grid-item-width));
  }
`;
